<script>
export default {
	props: {
		children: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	mounted() {
		if (this.active) {
			this.$parent.open = true;
		}
	},
};
</script>

<template>
<li
	:class="[
		{ active: active },
		'ro-nav-item',
	]">
	<slot />
	<ro-nav-item-toggle
		v-if="children"
	/>
</li>
</template>



// WEBPACK FOOTER //
// RoNavItem.vue?f8c4c930